var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEditDensities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.editDensities{fill:currentColor;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "editDensities",
    d: "M12.25,1H5.47L5.46,0.99L5.45,1h-1.7C2.23,1,1,2.24,1,3.75v8.5C1,13.77,2.23,15,3.75,15h8.51 c1.52,0,2.75-1.23,2.75-2.75v-8.5C15,2.24,13.77,1,12.25,1z M13.5,9.96L9.93,13.5H7.8l5.7-5.7V9.96z M12.41,2.53l-9.88,9.88 c-0.01-0.05-0.03-0.1-0.03-0.16v-1.93l7.82-7.82h1.93C12.3,2.5,12.35,2.53,12.41,2.53z M2.5,6.08L6.08,2.5H8.2L2.5,8.2V6.08z  M3.75,2.5h0.2L2.5,3.95v-0.2C2.5,3.06,3.06,2.5,3.75,2.5z M3.59,13.47l9.88-9.88c0.01,0.06,0.03,0.1,0.03,0.16v1.93L5.68,13.5H3.75 C3.69,13.5,3.65,13.48,3.59,13.47z M12.25,13.5h-0.2l1.44-1.43v0.18C13.5,12.94,12.94,13.5,12.25,13.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditDensities);
export default __webpack_public_path__ + "static/media/icon_edit-densities.aaa8bf6fdb3fa03c989d6259b548bb93.svg";
export { ForwardRef as ReactComponent };